
export function getIsAuthLoading(state) {
    return state.loading;
}

export function getToken(state) {
    return state.data ? state.data.user.token : null;
}
